module.exports = __webpack_public_path__ + "static/media/nike-land-of-new-football.dc49cc55.mp4";